import React, { useState } from 'react'
import { cpf } from 'cpf-cnpj-validator'
import CreditLogin from './CreditLogin'
import CreditSignup from './CreditSignup'
import CreditUpdateCpf from './CreditUpdateCpf'
import CreditPayment from './CreditPayment'
import CreditScreenView from './CreditScreenView'
import CreditInterestedPerson from './CreditInterestedPerson'
import isNull from 'lodash/isNull'
import isString from 'lodash/isString'
import isEmpty from 'lodash/isEmpty'
import isUndefined from 'lodash/isUndefined'
import get from 'lodash/get'
import useFacebook from '../../../../custom-hooks/useFacebook'
import { cleanupCPF, cleanupPhone, cleanupCreditCard, cleanupCEP } from '../../../../helpers/cleanup'
import { authenticateUser, registerUser, updateUser, authWithFacebook } from '../../../../services/auth'
import { sendCodeSMS, verifyCodeSMS } from '../../../../services/sms-code'
import { creditCardRecord } from '../../../../services/credit-card'
import { applyVoucher, purchaseRawConsult } from '../../../../services/credit'
import { getRawCreditConsult } from '../../../../services/bank'
import CreditPhoneValidation from './CreditPhoneValidation'
import Check from '../../../../assets/svgs/Check'
import './style.scss'

const CreditStepList = ({ urlData, customSignup }) => {
  const [step, setStep] = useState(1)
  const [isAUser, setIsAUser] = useState(false)
  const [pinCode, setPinCode] = useState()
  const [isLogin, setIsLogin] = useState(!urlData)
  const [smsInfo, setSmsInfo] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingVoucher, setIsLoadingVoucher] = useState(false)
  const [saveCreditCardNumber, setValueForSaveCreditCardNumber] = useState(false)
  const [infoScore, setInfoScore] = useState()
  const [payment, setPayment] = useState(true)
  const [name, setName] = useState(get(urlData, 'name', ''))
  const [voucher, setVoucher] = useState('')
  const [holderName, setHolderName] = useState('')
  const [cardNumber, setCardNumber] = useState('')
  const [expiryMonth, setExpiryMonth] = useState('01')
  const [expiryYear, setExpiryYear] = useState('2019')
  const [ccv, setCcv] = useState('')
  const [city, setCity] = useState('')
  const [postalCode, setPostalCode] = useState('')
  const [addressNumber, setAddressNumber] = useState('')
  const [stateAddress, setStateAddress] = useState('')
  const [cep, setCep] = useState('')
  const [password, setPassword] = useState('')
  const [confirmaPassword, setConfirmPassword] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState(get(urlData, 'phone', ''))
  const [emptyPhone, setEmptyPhone] = useState(false)
  const [cpfNumber, setCpfNumber] = useState('')
  const [consultedCpf, setConsultedCpf] = useState('')
  const [error, setError] = useState()
  const [success, setSuccess] = useState()
  const [user, setUser] = useState({})
  const [auth, setAuth] = useState(true)
  const [registerCpf, setRegisterCpf] = useState(true)
  const [codeSms, setCodeSms] = useState(true)
  const [interestedPerson, setInterestedPerson] = useState(true)
  const [listItem, setListItem] = useState([])
  const [visibleConsumeButton, setVisibleConsumeButton] = useState('false')

  const { fbSdkLoaded } = useFacebook()

  const onChange = (nextStep) => {
    setStep(nextStep < 0 ? 0 : nextStep > 4 ? 4 : nextStep)
  }

  const onNext = () => {
    onChange(step + 1)
    setListItem([...listItem, step])
  }

  const processFacebookData = async (accessToken) => {
    setVisibleConsumeButton(true)

    try {
      if (urlData) {
        const { user, access_token: token } = await customSignup({}, accessToken)
        if (user) {
          setUser(user)
          localStorage.setItem('accessToken', token)
          setUser(user)
          setAuth(false)
          onNext()
          return
        }
      }
      const { data } = await authWithFacebook(accessToken)
      if (data.user) {
        setUser(data.user)
        localStorage.setItem('accessToken', data.access_token)
        await setVisibleConsumeButton(false)
        setAuth(false)
        onNext()
      }
    } catch (error) {
      console.log('processFacebookData -> error', { error })
      setError(`Não foi possível salvar os seus filtros no momento. Tente novamente mais tarde.
      Informações técnicas: ${get(error, 'message', error)}`)
    }
  }

  const handleFacebookAuth = (e) => {
    e.preventDefault()

    window.FB.login(
      (response) => {
        if (response.status === 'connected') {
          // Logged into your webpage and Facebook.
          processFacebookData(response.authResponse.accessToken)
        } else {
          // The person is not logged into your webpage or we are unable to tell.
          console.log("couldn't log in with facebook")
        }
      },
      { scope: 'public_profile,email' },
    )
  }

  const handleWithAuth = async (type) => {
    if (type === 'login') {
      authenticateUser(email, password)
        .then((response) => {
          const localUser = response.user
          setUser(response.user)
          if (!isNull(response.accessToken)) {
            localStorage.setItem('accessToken', response.accessToken)
            setAuth(false)

            if (response.user.cpf && response.user.phone_confirmed) {
              setCodeSms(false)
              const listValueStep = [3]
              setListItem([...listItem, ...listValueStep])
              setIsAUser(true)
            } else {
              const smsPhone = isUndefined(localUser.phone)
                ? `55${cleanupPhone(phone)}`
                : `55${cleanupPhone(localUser.phone)}`
              sendCodeSMS(smsPhone, response.accessToken)
                .then((response) => setSmsInfo(response))
                .catch((error) => {
                  setError(
                    `Não foi possível enviar número de sms ao celular em questão. Informações técnicas: ${get(
                      error,
                      'message',
                      error,
                    )}`,
                  )
                })
              onNext()
              setError('')
            }
          }
        })
        .catch((error) => {
          console.log('authenticateUser -> error', { error })
          setError(`Não foi possivel realizar o seu login, email ou senha estão incorretos.
        Informações técnicas: ${get(error, 'message', error)}`)
        })
    }

    if (type === 'register') {
      if (confirmaPassword !== password) {
        setError('Confirmação de senha e senha não correspondem')
        return
      }

      if (isNull(phone) || isUndefined(phone)) {
        setError('Por favor, preencha o campo de telefone')
        return
      }

      if (!cpf.isValid(cpfNumber)) {
        setError('CPF Inválido, por favor, preencha um CPF válido')
        return
      }

      const userData = {
        name,
        password,
        email,
        phone: cleanupPhone(phone),
        cpf: cleanupCPF(cpfNumber),
      }

      const continueFn = () => {
        handleWithAuth('login')
        setAuth(false)
        onNext()
      }

      if (urlData) {
        return customSignup(userData)
          .then(({ user }) => {
            if (!isNull(user)) {
              continueFn()
            }
          })
          .catch((error) => {
            console.log('registerUser -> error', { error })
            setError(`Não foi possível realizar o seu cadastro.
            Informações técnicas: ${get(error, 'message', error)}`)
          })
      }

      registerUser(userData)
        .then(({ data }) => {
          if (!isNull(data.id)) {
            continueFn()
          }
        })
        .catch((error) => {
          if (error === 'duplicated_email') {
            setError('Esse email se encontra em uso')
          } else {
            setError(`Não foi possível realizar o seu cadastro.
          Informações técnicas: ${get(error, 'message', error)}`)
          }
        })
    }
  }

  const handleScoreCreditCardInfo = () => {
    const token = localStorage.getItem('accessToken')
    const cpf = cleanupCPF(consultedCpf)

    getRawCreditConsult(cpf, token)
      .then((res) => {
        setInfoScore(res.data.data)
      })
      .catch((error) => {
        console.log('getRawCreditConsult -> error', { error })
        setError(`Não foi possí­vel realizar a sua consulta.
        Informações técnicas: ${get(error, 'message', error)}`)
      })
  }

  const handleWithCpfValidation = (cpfNumber) => {
    if (!cpf.isValid(cpfNumber) || cpfNumber.length < 11) {
      setError('CPF Inválido, por favor, preencha um CPF válido')
    } else {
      setError('')
    }
  }

  const handleUpdateUser = () => {
    const accessToken = localStorage.getItem('accessToken')

    if (!cpf.isValid(cpfNumber)) {
      setError('CPF Inválido, por favor, preencha um CPF válido')
      return
    }

    updateUser(
      {
        id: user.id,
        name: user.name,
        email: user.email,
        roles: user.roles,
        phone: cleanupCPF(user.phone),
        user_link: user.link,
        cpf: cleanupCPF(cpfNumber),
      },
      accessToken,
    )
      .then((data) => {
        if (!isNull(data.id)) {
          setRegisterCpf(false)
          onNext()
        }
      })
      .catch((error) => {
        console.log('registerUser -> error', { error })
        setError(`Não foi possível realizar o seu cadastro.
        Informações técnicas: ${get(error, 'message', error)}`)
      })
  }

  const handleWitInterestedPerson = () => {
    if (isNull(user.facebook_id)) {
      setInterestedPerson(false)
      const newList = listItem.push(4)
      setRegisterCpf(false)
      setListItem(newList)
      onNext()
    }

    if (listItem.includes(3) && isAUser && !listItem.includes(4)) {
      setInterestedPerson(false)
      const listValueStep = [4]
      setListItem([...listItem, ...listValueStep])

      return
    }

    if (listItem.includes(4) && isAUser) {
      setInterestedPerson(false)
      const listValueStep = [4]
      setPayment(true)
      setListItem([...listItem, ...listValueStep])

      return
    }

    if (listItem.includes(4) && !isAUser) {
      setInterestedPerson(false)
      const newList = listItem.push(4)
      setPayment(true)
      setListItem(newList)

      onNext()
    } else {
      const newList = listItem.push(4)
      setListItem(newList)
      onNext()
      setInterestedPerson(false)
    }
  }

  const handleBackToInterestedPerson = () => {
    listItem.pop()
    setInterestedPerson(true)
    setPayment(false)
  }

  const handleVoucher = () => {
    const token = localStorage.getItem('accessToken')
    const consulted_cpf = cleanupCPF(consultedCpf)
    const code = voucher.toString()
    setIsLoadingVoucher(true)

    applyVoucher(consulted_cpf, code, token)
      .then(() => {
        setSuccess('Voucher aplicado com sucesso!')
        setIsLoadingVoucher(false)

        setPayment(false)
        setIsLoading(false)

        handleScoreCreditCardInfo()
        if (!listItem.includes(5)) {
          const listValueStep = [5]
          setListItem([...listItem, ...listValueStep])
        } else {
          onNext()
        }

        setError('')
      })
      .catch((error) => {
        console.log('registerUser -> error', { error })
        setError(`Não foi possível aplicar esse voucher.
      Informações técnicas: ${get(error, 'message', error)}`)
        setIsLoadingVoucher(false)
      })
  }

  const verifyData = (infoCreditCard) => {
    if (infoCreditCard.secondPurchase) {
      return {
        ...infoCreditCard.card,
        cpfCnpj: infoCreditCard.card.cpfCnpj,
      }
    } else {
      const data = {
        holderName: holderName,
        number: cleanupCreditCard(cardNumber),
        expiryMonth: expiryMonth,
        expiryYear: expiryYear,
        ccv: ccv,
        email: user.email,
        cpf: cleanupCPF(user.cpf),
        postalCode: cleanupCEP(cep),
        addressNumber: `${addressNumber} - ${postalCode} - ${city} - ${stateAddress}/${cep}`,
        phone: cleanupPhone(user.phone),
      }
      return data
    }
  }

  const handlePurchase = (infoCreditCard, creditCard = false) => {
    const token = localStorage.getItem('accessToken')
    setIsLoading(true)

    const data = verifyData(infoCreditCard)

    const handleWithOutSaveACreditcard = (creditCard, data, consulted_cpf) => {
      if (creditCard) {
        handleBuyVerifyScore(data, consulted_cpf, 'consult')
      } else {
        const creditCardInfo = { ...data, cpfCnpj: data.cpf }
        handleBuyVerifyScore(creditCardInfo, consulted_cpf, 'consult')
      }
    }

    const handleBuyVerifyScore = (creditcard_data, consulted_cpf, description) => {
      purchaseRawConsult(creditcard_data, consulted_cpf, description, token)
        .then((res) => {
          setPayment(false)
          setIsLoading(false)
          if (!listItem.includes(5)) {
            const listValueStep = [5]
            setListItem([...listItem, ...listValueStep])
          } else {
            onNext()
          }

          setError('')
        })
        .catch((error) => {
          console.log('purchaseRawConsult -> error', { error })
          setError(`Não foi possível realizar a compra.
        Informações técnicas: ${get(error, 'message', error)}`)
          setIsLoading(false)
        })
    }

    const consulted_cpf = cleanupCPF(consultedCpf)

    if (saveCreditCardNumber) {
      creditCardRecord(data, token)
        .then((res) => {
          handleBuyVerifyScore(res?.data, consulted_cpf, 'consult')
        })
        .catch((error) => {
          console.log('creditCardRecord -> error', { error })
          setIsLoading(false)
          setError(
            `Não foi possível realizar o seu cadastro. Informações técnicas: ${get(error, 'message', error)}`,
          )
        })
    } else {
      handleWithOutSaveACreditcard(creditCard, data, consulted_cpf)
    }
  }

  const handleWithResendSMS = () => {
    const token = localStorage.getItem('accessToken')
    if (!user.phone_confirmed) {
      return
    }

    if (isEmpty(user) && !isString(phone)) {
      if (isNull(user.phone) || isUndefined(user.phone)) {
        setEmptyPhone(true)
      }
    }

    if (isNull(phone) || isUndefined(phone)) {
      setEmptyPhone(true)
    }

    const smsPhone = isUndefined(user.phone) ? `55${cleanupPhone(phone)}` : `55${cleanupPhone(user.phone)}`
    sendCodeSMS(smsPhone, token)
      .then((response) => setSmsInfo(response))
      .catch((error) => {
        setError(`Não foi possível enviar número de sms ao celular em questão.
        Informações técnicas: ${get(error, 'message', error)}`)
        console.log('handleWithResendSMS -> error', { error })
      })
  }

  const handleWithPinValidation = () => {
    const token = localStorage.getItem('accessToken')
    const userId = user.id
    const pinId = get(smsInfo, 'res.pinId')

    verifyCodeSMS(pinCode, userId, pinId, token)
      .then((response) => {
        if (!isNull(user.facebook_id)) {
          onNext()
          setCodeSms(false)
        } else if (response.status === 'OK' && !user.facebook_id) {
          const listValueStep = [3]
          setListItem([...listItem, ...listValueStep])
          setCodeSms(false)
        }
      })
      .catch((error) => console.log('verifyCodeSMS -> error', { error }))
  }

  const handleAuthWithView = (view) => setIsLogin(!view)

  const handleWithStepNumber = (stepNumber) => (isAUser ? stepNumber - 2 : stepNumber)

  const handleSaveCreditCard = (e) => {
    if (e.target.checked) {
      setValueForSaveCreditCardNumber(!saveCreditCardNumber)
    } else {
      setValueForSaveCreditCardNumber(!saveCreditCardNumber)
    }
  }

  const onInputChange = (input, hook) => {
    hook(input)
    setError('')
  }

  return (
    <div>
      <div className='container'>
        <ul>
          <li>
            <span className='dot'>{auth ? 1 : <Check />}</span>
            <div>Faça o login ou se cadastre</div>
            {auth && (
              <div>
                {isLogin ? (
                  <CreditLogin
                    fbSdkLoaded={fbSdkLoaded}
                    error={error}
                    email={(e) => onInputChange(e.target.value, setEmail)}
                    password={(e) => onInputChange(e.target.value, setPassword)}
                    handleWithAuth={() => handleWithAuth('login')}
                    handleFacebookAuth={(e) => handleFacebookAuth(e)}
                    handleAuthWithView={() => handleAuthWithView(true)}
                    visibleConsumeButton={visibleConsumeButton}
                  />
                ) : (
                  <CreditSignup
                    error={error}
                    dynamicData={{ phone, name }}
                    name={(e) => onInputChange(e.target.value, setName)}
                    password={(e) => onInputChange(e.target.value, setPassword)}
                    confirmPassword={(e) => onInputChange(e.target.value, setConfirmPassword)}
                    email={(e) => onInputChange(e.target.value, setEmail)}
                    phone={(e) => onInputChange(e.target.value, setPhone)}
                    cpf={(e) => {
                      handleWithCpfValidation(e.target.value)
                      onInputChange(e.target.value, setCpfNumber)
                    }}
                    handleWithAuth={() => handleWithAuth('register')}
                    handleAuthWithView={() => handleAuthWithView(false)}
                  />
                )}
              </div>
            )}
          </li>
          {listItem.includes(1) && (
            <li>
              <span className='dot'>{codeSms ? 2 : <Check />}</span>
              <div>Validação do Celular</div>

              <CreditPhoneValidation
                codeSms={codeSms}
                error={error}
                phone={(e) => onInputChange(e.target.value, setPhone)}
                emptyPhone={emptyPhone}
                setPinCode={(value) => setPinCode(value)}
                handleWithPinValidation={() => handleWithPinValidation()}
                handleWithResendSMS={() => handleWithResendSMS()}
                handleSendSMS={() => handleWithResendSMS()}
              />
            </li>
          )}
          {listItem.includes(2) && (
            <li>
              <span className='dot'>{registerCpf ? 3 : <Check />}</span>
              <div>Cadastre seu CPF</div>

              <CreditUpdateCpf
                error={error}
                registerCpf={registerCpf}
                handleChangeCpf={(e) => {
                  handleWithCpfValidation(e.target.value)
                  onInputChange(e.target.value, setCpfNumber)
                }}
                handleUpdateUser={handleUpdateUser}
              />
            </li>
          )}
          {listItem.includes(3) && (
            <li>
              <span className='dot'>{interestedPerson ? handleWithStepNumber(4) : <Check />}</span>
              <div>Insira os dados do Interessado</div>

              <CreditInterestedPerson
                error={error}
                interestedPerson={interestedPerson}
                handleChangeName={(e) => onInputChange(e.target.value, setName)}
                handleChangeCpf={(e) => {
                  handleWithCpfValidation(e.target.value)
                  onInputChange(e.target.value, setConsultedCpf)
                }}
                handleWitInterestedPeople={() => handleWitInterestedPerson()}
              />
            </li>
          )}
          {listItem.includes(4) && (
            <li>
              <span className='dot'>{payment ? handleWithStepNumber(5) : <Check />}</span>
              <div>Pagamento</div>
              <CreditPayment
                isLoading={isLoading}
                isLoadingVoucher={isLoadingVoucher}
                saveCreditCardNumber={saveCreditCardNumber}
                success={success}
                error={error}
                payment={payment}
                userId={user?.id}
                voucher={(e) => onInputChange(e.target.value, setVoucher)}
                holderName={(e) => onInputChange(e.target.value, setHolderName)}
                creditCardNumber={(e) => onInputChange(e.target.value, setCardNumber)}
                expiryMonth={(e) => onInputChange(e.target.value, setExpiryMonth)}
                expiryYear={(e) => onInputChange(e.target.value, setExpiryYear)}
                ccv={(e) => onInputChange(e.target.value, setCcv)}
                postalCode={(e) => onInputChange(e.target.value, setPostalCode)}
                addressNumber={(e) => onInputChange(e.target.value, setAddressNumber)}
                city={(e) => onInputChange(e.target.value, setCity)}
                stateAddress={(e) => onInputChange(e.target.value, setStateAddress)}
                cep={(e) => onInputChange(e.target.value, setCep)}
                onPrevious={() => handleBackToInterestedPerson()}
                handlePurchase={(data, creditCard) => handlePurchase(data, creditCard)}
                handleSaveCreditCard={(e) => handleSaveCreditCard(e)}
                handleVoucher={() => handleVoucher()}
              />
            </li>
          )}
          {listItem.includes(5) && (
            <li>
              <span className='dot'>{infoScore ? handleWithStepNumber(6) : <Check />}</span>
              <div>Acessar avaliação</div>
              <CreditScreenView
                handleScoreCreditCardInfo={() => handleScoreCreditCardInfo()}
                infoScore={infoScore}
              />
            </li>
          )}
        </ul>
      </div>
    </div>
  )
}

export default CreditStepList
